import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../AxiosConfig';
import UserStore from '../../store/user-store';

const fetchReferrals = async () => {
    const response = await apiClient.get('/v1/referrals/');
    return response.data;
};

export const useReferrals = () => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ['referrals'],
        queryFn: fetchReferrals,
        enabled: Boolean(UserStore.userAccessToken),
        refetchInterval: 30000, // Refetch every 30 seconds
    });

    return {
        referrals: data?.referrals || [],
        totalProfit: data?.total_profit || {},
        referralData: data?.referral_data || {},
        progressData: data?.progress_data || {},
        isLoading,
        error,
        refetch
    };
}; 